export const PATHS = {
  home: "/",
  intake: "/intake",
  intakeLane: (lane: string) => `/intake/${lane}`,
  data: "/data",
  cockpit: "/consultant-cockpit",
  nomenclature: "/consultant-cockpit/nomenclature",
  plantRegistry: "/plant-registry",
  polymerGroups: "/plant-registry/groups",
  adminUsers: "/admin/users",
} as const;
